export const moduleSectionFieldNameMapper = (moduleName, wasteFields) => {
  const allSectionsAndFields = {
    DELIVERY: {
      Delivery: [
        'deliveryArrivalDate',
        'deliveryExitDate',
        'deliveryId',
        'deliveryAddressKnown',
        'dispatchAddressKnown',
        'receiverReferenceNumber'
      ],
      Supplier: [
        'supplierName',
        'supplierReferenceNumber',
        'tradeContractor',
        'vehicleRegistration',
        'clientReference',
        'notes'
      ],
      Products: [
        'name',
        'productGroups',
        'productionTime',
        'usedAtTime',
        'measurementHeight',
        'measurementWidth',
        'measurementLength',
        'measurementGivenVolume',
        'measurementWeight',
        'quantity',
        'givenCertifications'
      ]
    },
    WASTE: {
      General: [
        'removalDate',
        'removalExitDate',
        'consignmentId',
        'receiverReferenceNumber',
        'subcontractorName',
        'originSiteAddressKnown',
        'classificationCode',
        'vehicleRegistration'
      ],
      Carrier: ['carrierName', 'supplierReferenceNumber', 'carrierLicenceId'],
      Facility: [
        'facilityOperatorName',
        'facilitySiteAddress',
        'facilityPermitId',
        'clientReference',
        'notes'
      ],
      Items: [
        'containerType',
        'wasteDescription',
        'wasteCode',
        'measurementVolume',
        'measurementWeight',
        'quantity'
      ]
    }
  }

  // Now filter out any fields that are not relevant to the country
  if (moduleName === 'WASTE') {
    Object.keys(allSectionsAndFields.WASTE).forEach(section => {
      allSectionsAndFields.WASTE[section] = allSectionsAndFields.WASTE[
        section
      ].filter(field => wasteFields[field])
    })
  }

  return allSectionsAndFields[moduleName] || {}
}

export const fieldNameLabelMapper = overwriteText => {
  return {
    DELIVERY: {
      clientReference: 'External reference',
      deliveryAddressKnown: 'Site address',
      deliveryArrivalDate: 'Arrival date and time',
      deliveryExitDate: 'Exit date and time',
      deliveryId: 'Delivery ID',
      dispatchAddressKnown: 'Dispatch address',
      givenSupplierCertifications: 'Certifications',
      notes: 'Notes',
      receiverReferenceNumber: 'Receiver reference',
      supplierName: 'Company name',
      supplierReferenceNumber: 'Reference',
      tradeContractor: 'Trade contractor',
      vehicleRegistration: 'Vehicle registration',
      // Products
      givenCertifications: 'Certifications',
      givenVolume: 'Volume',
      height: 'Height',
      length: 'Length',
      measurementGivenVolume: 'Volume',
      measurementHeight: 'Height',
      measurementLength: 'Length',
      measurementWeight: 'Weight',
      measurementWidth: 'Width',
      name: 'Name',
      productGroups: 'Product groups',
      productionTime: 'Produced at',
      quantity: 'Quantity',
      usedAtTime: 'Used at',
      weight: 'Weight',
      width: 'width'
    },
    WASTE: {
      carrierLicenceId: 'Licence',
      carrierName: overwriteText.carrierName,
      classificationCode: 'SIC code',
      classificationCodePresented: 'SIC code provided',
      clientReference: 'External reference',
      consignmentId: overwriteText.consignmentNumber,
      facilityOperatorName: 'Operator',
      facilityPermitId: 'Permit',
      facilityPermitPresented: 'Permit provided',
      facilitySiteAddress: 'Site address',
      notes: 'Notes',
      originSiteAddressKnown: 'Origin site address',
      receiverReferenceNumber: 'Sender reference',
      removalDate: 'Arrival date and time',
      removalExitDate: 'Exit date and time',
      subcontractorName: 'Subcontractor',
      supplierReferenceNumber: 'Reference',
      vehicleRegistration: 'Vehicle reg',
      // Items
      containerType: 'Container type',
      isRemoved: 'Removed',
      measurementVolume: 'Volume',
      measurementWeight: 'Weight',
      quantity: 'Quantity',
      volume: 'Volume',
      wasteCode: 'Waste code (EWC)',
      wasteDescription: 'Waste description',
      weight: 'Weight'
    }
  }
}
